import * as yup from "yup"

const Loginschema = yup
    .object({
        email: yup.string().required().matches(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, "Invalid mail format"),
        password: yup.string().required().min(8, "minimum length is 8")
    })
    .required()
export default Loginschema